import { RecipeService } from "../../services/models/recipe/recipe_aps";
import { formatRut } from "@/services/utils";
const moduleRecipeAps = {
  namespaced: true,
  state: {
    recipes: [],
    loading: false,
  },
  getters: {
    getRecipes(state) {
      return state.recipes;
    },
    getLoading(state) {
      return state.loading;
    },
  },
  mutations: {
    loadRecipes(state, recipes) {
      state.recipes = recipes;
    },
  },
  actions: {
    async loadRecipes({ commit, state, rootGetters }) {
      state.loading = true;
      commit("loadRecipes", []);
      const rut = rootGetters["patient/getPatientRut"];
      let rutWithoutFormat = formatRut(rut);
      let rutWithoutPoint = rutWithoutFormat.replaceAll(".", "").replaceAll("-", "");

      let recipes = await RecipeService.getByRut(rutWithoutPoint);

      let groupByCategory = recipes.reduce((group, recipe) => {
        const { n_recipe } = recipe;
        group[n_recipe] = group[n_recipe] ?? [];
        group[n_recipe].push(recipe);
        return group;
      }, {});
      let labelRecipe = [];
      let detailRecipe = [];
      let i = 0;
      for (let key in groupByCategory) {
        groupByCategory[key].forEach((element) => {
          if (i <= groupByCategory[key].length) {
            i++;
            detailRecipe.push({
              id: element.id,
              article: element.article,
              posology: element.posology,
            });
            if (i == groupByCategory[key].length) {
              i = 0;
              labelRecipe.push({
                cie_10: element.cie_10,
                diagnostic: element.diagnostic,
                expire_recipe: element.expire_recipe,
                prof: element.prof,
                rut: element.rut,
                n_recipe: element.n_recipe,
                type_recipe: element.type_recipe,
                state: element.state,
                stablishment: element.stablishment,
                detailRecipe: detailRecipe,
              });
              detailRecipe = [];
            }
          }
        });
      }
      recipes = labelRecipe;
      console.log(recipes);
      //let recipes = await HcmService.getPatientRecipe(rut.split("-")[0]);
      commit("loadRecipes", recipes);
      state.loading = false;
    },
  },
};

export default moduleRecipeAps;
